export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const MEDIA_BASE_URL = API_BASE_URL.replace("/signing-portal", "") + "/media";

// LS KEYS
export const SIGNING_PORTAL_AUTH_TOKEN_KEY = "_lg_sp_auth_token";

// SYSTEM CONSTANTS
export const SIGN_METHOD_SIGNING_PORTAL = "signing_portal";
